import { render, staticRenderFns } from "./VI.vue?vue&type=template&id=f3e22f38&scoped=true"
import script from "./VI.vue?vue&type=script&lang=js"
export * from "./VI.vue?vue&type=script&lang=js"
import style0 from "./VI.vue?vue&type=style&index=0&id=f3e22f38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e22f38",
  null
  
)

export default component.exports